export const TABLE_HEAD = [
  { id: 'lead_created_time', label: 'Date', alignRight: false, width: 110, minWidth: 110, maxWidth: 150 },
  { id: 'lead_campaign', label: 'Campaign', alignRight: false, width: 100 },
  { id: 'lead_first_name', label: 'Name', alignRight: false, width: 250, minWidth: 200, maxWidth: 350 },
  { id: 'lead_email', label: 'Email', alignRight: false, width: 350, minWidth: 300, maxWidth: 450 },
  { id: 'lead_experience', label: 'Exp', alignRight: false, width: 150, maxWidth: 200 },
  { id: 'lead_phone_number', label: 'Phone', alignRight: false, width: 150, minWidth: 160, maxWidth: 190 },
  { id: 'lead_status', label: 'Status', alignRight: false, width: 170, minWidth: 170, maxWidth: 350 },
  { id: 'note', label: 'Note', alignRight: true, width: 150, minWidth: 150 },
  { id: 'lead_owner_op', label: 'O/O', alignRight: false, width: 70, minWidth: 70, maxWidth: 100 },
  { id: 'lead_truck_type', label: 'Model', alignRight: false, width: 150 },
  { id: 'state', label: 'State', alignRight: false, width: 150 },
  { id: 'last_status_update', label: 'Last Status Update', alignRight: false, width: 170, minWidth: 170 },
  { id: 'lp_experience', label: 'LP Experience', alignRight: false, width: 130 },
  { id: 'interested_in', label: 'Interested In', alignRight: false, width: 150, minWidth: 150 },
  { id: 'preferred_trailer_type', label: 'PTT', alignRight: false, width: 100 },
  { id: 'truck_preferences', label: 'Truck Preferences', alignRight: false, width: 160 },
  { id: 'violation', label: 'Violation', alignRight: false, width: 90 },
  { id: 'accident', label: 'Accident', alignRight: false, width: 90 },
  { id: 'drug_test', label: 'Drug Test', alignRight: false, width: 100 },
  { id: 'mvr', label: 'MVR', alignRight: false, width: 70, minWidth: 70 },
  { id: 'clearing_house', label: 'Clearing house', alignRight: false, width: 130 },
  { id: 'dui_sap', label: 'DUI / SAP', alignRight: false, width: 100 },
  { id: 'home_time', label: 'Home Time', alignRight: false, width: 100 },
  { id: 'start_time', label: 'Start Time', alignRight: false, width: 100 },
  { id: 'previous_company', label: 'Previous Company', alignRight: false, width: 150 },
  { id: 'previous_employment', label: 'Previous Employment', alignRight: false, width: 180 },
  { id: 'previous_position', label: 'Previous Position', alignRight: false, width: 150 },
  { id: 'why', label: 'Why', alignRight: false, width: 80, minWidth: 70 },
  { id: 'previous_miles', label: 'Previous Miles', alignRight: false, width: 130 },
  { id: 'previous_pay', label: 'Previous Pay', alignRight: false, width: 120 },
  { id: 'endorsements', label: 'Endorsements', alignRight: false, width: 130 },
  { id: 'summary', label: 'Summary', alignRight: false, width: 100 },
  { id: 'recruiter_id', label: 'Recruiter', alignRight: false, width: 130 },
];

export const displayDashboardColumns = {
  Date: true,
  Name: true,
  Email: true,
  Exp: true,
  Phone: true,
  Campaign: false,
  Status: true,
  'O/O': true,
  Model: true,
  Note: true,
  State: false,
  'Last Status Update': false,
  'LP Experience': false,
  'Interested In': false,
  PTT: false,
  'Truck Preferences': false,
  Violation: false,
  Accident: false,
  'Drug Test': false,
  MVR: false,
  'Clearing house': false,
  'DUI / SAP': false,
  'Home Time': false,
  'Start Time': false,
  'Previous Company': false,
  'Previous Employment': false,
  'Previous Position': false,
  Why: false,
  'Previous Miles': false,
  'Previous Pay': false,
  Endorsements: false,
  Summary: false,
  Recruiter: false,
};
